import { graphql } from "@/gql";

export const bookingTaskCountQuery = graphql(`
  query BookingTaskCount(
    $where: QueryTasksWhereWhereConditions
    $status: [TaskStatus!]
  ) {
    tasks(first: 1, status: $status, where: $where) {
      paginatorInfo {
        total
      }
    }
  }
`);
